import type { Entity as BreezeEntity } from 'breeze-client';
import {EntityChangedEventArgs, PropertyChangedEventArgs} from 'breeze-client';

export type Entity<T> = BreezeEntity & T;

export type BreezeEntityChangedEventArgs<T> = EntityChangedEventArgs & {
    entity: Entity<T>;
    args: PropertyChangedEventArgs;
};
